'use strict';

/**
 * SocialShare
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.SocialShare = T.createModule({

	_selectors: {
		socialShare: '[data-js-m-social-share__share-link]',
		closeShare: '[data-js-m-social-share__close-link]',
		services: '[data-js-m-social-share__services]',
		service: '[data-js-m-social-share__service]'
	},

	_stateClasses: {
		shareOpen: 'state-open'
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		this.pageTitle = this.$ctx.data('page-title');
		this.pageUrl = this.$ctx.data('page-url');

		this.shareUrls = {
			'xing': 'https://www.xing.com/spi/shares/new?url=' + this.pageUrl,
			'linkedin': 'https://www.linkedin.com/shareArticle?mini=true&title=&summary=&source=&url=' + this.pageUrl,
			'twitter': 'https://twitter.com/intent/tweet?text=' + this.pageTitle + ',&url=' + this.pageUrl,
			'email': 'mailto:?subject=' + this.pageTitle + '&body=' + this.pageUrl
		};

		this.$shareLink = this.$ctx.find(this._selectors.socialShare);
		this.$closeLink = this.$ctx.find(this._selectors.closeShare);
		this.$services = this.$ctx.find(this._selectors.services);
		this.$service = this.$ctx.find(this._selectors.service);

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));

		this.$shareLink.on('click', this.onShareLinkClick.bind(this));
		this.$closeLink.on('click', this.onCloseLinkClick.bind(this));
		this.$service.on('click', this.onServiceClick.bind(this));

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {},


	/**
  * Closes the share options
  *
  * @returns {void}
  */
	closeShareOptions: function closeShareOptions() {
		var _this = this;

		$(document).off('click.share');
		$(document).off('keyup.share');

		this.$services.animate({ maxWidth: 0 }, 200, 'linear', function () {
			_this.$ctx.removeClass(_this._stateClasses.shareOpen);
			_this.$services.attr('aria-hidden', 'true');
		});
	},


	/**
  * Opens the share options
  *
  * @returns {void}
  */
	openShareOptions: function openShareOptions() {
		var _this2 = this;

		this.$ctx.addClass(this._stateClasses.shareOpen);
		this.$services.removeAttr('aria-hidden');

		var cssProperties = { maxWidth: '220px' };

		this.$services.animate(cssProperties, 200, 'linear', function () {
			$(document).on('click.share', _this2.onClickDocument.bind(_this2));
			$(document).on('keyup.share', _this2.onKeyUp.bind(_this2));
		});
	},


	/**
  * Event when the user clicks on the close link
  *
  * @param {Event} ev - the click event
  * @returns {void}
  */
	onCloseLinkClick: function onCloseLinkClick(ev) {
		ev.preventDefault();

		this.closeShareOptions();
	},


	/**
  * Event when the user clicks on the document outside the popover
  *
  * @param {Event} ev The click event
  * @returns {void}
  */
	onClickDocument: function onClickDocument(ev) {
		var $target = $(ev.target);
		if (!$target.closest(this.$services).length && !$target.closest(this.$shareLink).length) {
			this.closeShareOptions();
		}
	},


	/**
  * Event when the user hits the esc key
  *
  * @param {Event} ev The keyup event
  * @returns {void}
  */
	onKeyUp: function onKeyUp(ev) {
		ev.preventDefault();

		if (ev.which === 27) {
			this.closeShareOptions();
		}
	},


	/**
  * Event when the user clicks on one of the sharing services
  *
  * @param {Event} ev - the click event
  * @returns {boolean} If the event should be proceeded
  */
	onServiceClick: function onServiceClick(ev) {

		var $target = $(ev.target).closest(this._selectors.service);
		var url = this.shareUrls[$target.data('service')];

		if (url !== undefined) {
			$target.attr('href', encodeURI(url));

			return true;
		}

		return false;
	},


	/**
  * Event when the user clicks on the share link
  *
  * @param {Event} ev - the click event
  * @returns {void}
  */
	onShareLinkClick: function onShareLinkClick(ev) {
		ev.preventDefault();

		this.openShareOptions();
	}
});